$(document).ready(function(){

    function checkIfPopupClicked(){
        var currentLocation = String(window.location.href);
        if (currentLocation.indexOf('?locationApproved') != -1){
            var expires = new Date();
            expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
            document.cookie = "PopupHidden=1; expires=" + expires.toUTCString() + "; path=/";
        }
    }

    checkIfPopupClicked();

    function getCurrentCountry() {
        var endpoint = 'https://apip.cc/json';
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState == 4 && this.status == 200) {
                var response = JSON.parse(this.responseText);
                if (response.status !== 'success') {
                    console.log('Query failed: ' + response.message);
                    return;
                }
                

                var currentCountry = response.CountryName;
                var currentCode = response.CountryCode;
    
                // Testing location
                // currentCode = 'GB';
                // currentCountry = 'United Kingdom';

                // currentCode = 'AT';
                // currentCountry = 'Austria';

                

                // currentCode = 'LU';
                // currentCountry = 'Luxembourg';

                // console.log(country, 'TESTING');

                if(currentCode == 'LU'){
                    currentCode = 'LX';
                }

                // currentCode = 'BE';
                // currentCountry = 'Belgium';

                // currentCode = 'LV';
                // currentCountry = 'Latvia';

                var translatedCountryMain = '';

                var recommendedVisible = 0;
                var recommendeFlag = ''; 
                var shippingText = '';
            
                // Translate country name to German
                if(currentCode == 'LT'){
                    var translatedCountry = countryTranslationsLt[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainLt[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/Flag_of_Lithuania_2.png?v=1739516525';
                    $('.lp_countries_lin[data-country-code="desktronic-lt"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-lt"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-lt"]').trigger('click');
                    shippingText = $('[data-country-old="lithuania"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="LT"]').html();
                }
                else if(currentCode == 'DE' || currentCode == 'AT'){
                    var translatedCountry = countryTranslationsDe[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainDe[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/de.png?v=1739949775';
                    $('.lp_countries_lin[data-country-code="desktronic-de"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-de"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-de"]').trigger('click');
                    shippingText = $('[data-country-old="german"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="DE"]').html();
                }
                else if(currentCode == 'FR'){
                    var translatedCountry = countryTranslationsFr[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainFr[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/fr.png?v=1739949775';
                    $('.lp_countries_lin[data-country-code="desktronic-fr"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-fr"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-fr"]').trigger('click');
                    shippingText = $('[data-country-old="france"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="FR"]').html();
                }
                else if(currentCode == 'GB'){
                    var translatedCountry = countryTranslationsUk[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainUk[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/uk.png?v=1739949775';
                    $('.lp_countries_lin[data-country-code="desktronic-co-uk"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-co-uk"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-co-uk"]').trigger('click');
                    shippingText = $('[data-country-old="united-kingdom"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="US"]').html();
                }
                else if(currentCode == 'LU' || currentCode == 'LX' ){
                    var translatedCountry = countryTranslationsLu[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainLu[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/be.png?v=1739949776';
                   
                    $('.lp_countries_lin[data-country-code="desktronic-be"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-be"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-be"]').trigger('click');
                    shippingText = $('[data-country-old="belgium"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="BE"]').html();
                }
                else if(currentCode == 'BE'){
                    var translatedCountry = countryTranslationsBe[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainBe[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/be.png?v=1739949776';
                    $('.lp_countries_lin[data-country-code="desktronic-be"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-be"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-be"]').trigger('click');
                    shippingText = $('[data-country-old="belgium"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="BE"]').html();
                }
                else if(currentCode == 'NL'){
                    var translatedCountry = countryTranslationsNl[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainNl[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/be.png?v=1739949776';
                    $('.lp_countries_lin[data-country-code="desktronic-nl"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-nl"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-nl"]').trigger('click');
                    shippingText = $('[data-country-old="netherlands"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="NL"]').html();
                }
                else if(currentCode == 'PL'){
                    var translatedCountry = countryTranslationsPl[currentCountry] || currentCountry;
                    translatedCountryMain = countryTranMainPl[currentCountry] || currentCountry;
                    recommendedVisible = 1;
                    recommendeFlag = 'https://cdn.shopify.com/s/files/1/0511/8961/2733/files/be.png?v=1739949776';
                    $('.lp_countries_lin[data-country-code="desktronic-pl"]').show();
                    $('.lp_countries_lin[data-country-old="desktronic-pl"]').hide();
                    $('.lp_countries_lin.selectedList[data-country-code="desktronic-pl"]').trigger('click');
                    shippingText = $('[data-country-old="poland"]').find('.lp_very_small').find('.lp_selected_line__js[data-country="PL"]').html();
                }
                else{
                    var translatedCountry = countryTranslationsUk[currentCountry] || 'in ' + currentCountry;
                    translatedCountryMain = countryTranMainUk[currentCountry] || currentCountry;
                    recommendedVisible = 0;
                }

                if (recommendedVisible == 0){
                    $('.lp_countries_lin[data-recommended]').hide();
                    $('.lp_selected_line__js[data-country="GB"]').show();
                    $('.lp_countries_lin[data-default][data-index="1"]').trigger('click');
                }

              
                

                // console.log(recommendedVisible, 'RECOMMENDED');

                // Setting title with translated country
                $('[data-lp-country]').each(function(){
                    var currentPopupTitle = $(this).html();
                    currentPopupTitle = currentPopupTitle.replace('COUNTRY', translatedCountry);
                    $(this).html(currentPopupTitle);
                });

                var currentText = $('.lp_text.not_exists').html();
                currentText = currentText.replace('COUNTRY', translatedCountry);
                $('.lp_text.not_exists').html(currentText);
                

                $('.lp_outer').addClass('activeIn');

                setPopupLocalization(currentCode, recommendedVisible);
            }
        };
        xhr.open('GET', endpoint, true);
        xhr.send();
    }


    function setPopupLocalization(country, recommendedVisible){
        console.log(country);

        if (country == 'GB' ){

        }
        else{
            showLocalizationPopup();
        }


        $('.lp_label[data-country="'+country+'"]').show();
        $('.lp_selected_line__js[data-country="'+country+'"]').show();

        // console.log(country, 'TESTING');
        $('[data-lp-store][data-country="'+country+'"]').show();
        if (recommendedVisible > 0){
            $('.lp_text.exists[data-country="'+country+'"]').show();
        }
        else{
            $('.lp_text.not_exists[data-country="'+country+'"]').show();
        }
        
        $('.lp_title[data-country="'+country+'"]').show();
        $('.btn_text[data-country="'+country+'"]').show();
        $('.lp_region_title_in[data-country="'+country+'"]').show();
       
        if(
            country == 'LT' || 
            country == 'FR' ||
            country == 'DE' ||
            country == 'AT' ||
            country == 'NL' ||
            country == 'BE' ||
            country == 'GB' ||
            country == 'PL' || 
            country == 'LX' ||
            country == 'LU'
        ){
          
        }
        else{
            $('.lp_label[data-country="GB"]').show();
            $('.lp_text[data-country="GB"]').show();
            $('.lp_title[data-country="GB"]').show();
            $('.btn_text[data-country="GB"]').show();
            $('.lp_region_title_in[data-country="GB"]').show();
        }
        
        if (recommendedVisible > 0){
            $('.lp_text.not_exists').hide();
        }
        else{
            $('.lp_text.exists').hide();
        }

    }
    

    getCurrentCountry();

    function getCookie(name) {
        let matches = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        return matches ? matches[2] : null;
    }
    
    function showLocalizationPopup() {
        if (getCookie("PopupHidden") === "1") {
            // console.log('PopupHiddenFound');
            return;  
        }
        $('body').addClass('popup-open');
        $('.lp_outer[data-popup="start"]').css('display', 'flex');
        setTimeout(function(){
            $('.lp_outer').addClass('visible');
        }, 1000);
    }
    
    

    

    $('.pp_close_btn').click(function(){
        $('.lp_outer').removeClass('visible');
        setTimeout(function(){
            $('.lp_outer').hide();
            $('body').removeClass('popup-open');
        },500);

        var expires = new Date();
        expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
        document.cookie = "PopupHidden=1; expires=" + expires.toUTCString() + "; path=/";
    });

    $('.lp_outer.visible').click(function(evt){
        if (!$(evt.target).closest('.lp_inner').length) {  
            $('.lp_outer').removeClass('visible');
            setTimeout(function(){
                $('.lp_outer').hide();
                $('body').removeClass('popup-open');
            },500);
        }

        var expires = new Date();
        expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
        document.cookie = "PopupHidden=1; expires=" + expires.toUTCString() + "; path=/";
    });

    $('.lp_select_region').click(function(){
        $(this).toggleClass('active');
        $('.lp_countries_selection_box').slideToggle();
    });

    $('.lp_btn_decline').click(function(){
        $('.lp_outer').removeClass('visible');
        setTimeout(function(){
            $('.lp_outer').hide();
            $('body').removeClass('popup-open');
            // Set cookie for 1 week
            var expires = new Date();
            expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
            document.cookie = "PopupHidden=1; expires=" + expires.toUTCString() + "; path=/";
        }, 500);
    });

    $('.lp_inner').click(function(evt) {
        // console.log(evt.target);
        if (!$(evt.target).closest('.lp_select_region_outer').length) {  
            if ($('.lp_select_region').hasClass('active')) {
                $('.lp_select_region').removeClass('active');
                $('.lp_countries_selection_box').slideUp();
            }
        }
    });

    $('.lp_countries_lin').click(function(){

        $('.lp_select_region').removeClass('active');
        $('.lp_countries_selection_box').slideUp();

        var currentCountry = $(this).find('.lp_region_title').html();
        var currentRecommended = $(this).find('.lp_very_small').html();
        var currentImage = $(this).find('.lp_region_flag img').attr('src');
        var currentUrl = $(this).find('.lp_region_info').attr('data-href') + '?locationApproved';

        $('.lp_select_region').find('.lp_selectedTitle').html(currentCountry);
        $('.lp_select_region').find('.lp_selectedRecommended').html(currentRecommended);
        $('.lp_select_region').find('.lp_selectedIcon').attr('src', currentImage);

        $('.lp_btn.primary').attr('href', currentUrl);

        $(this).closest('.lp_inner').find('.lp_countries_lin').removeClass('selectedList');
        $(this).addClass('selectedList');

        $(this).closest('.lp_inner').find('.lp_countries_lin').removeClass('selectedBeforeList');
        if (String($(this).prev('.lp_countries_lin').attr('style')).indexOf('none') != -1){
            $(this).prev('.lp_countries_lin').prev('.lp_countries_lin').addClass('selectedBeforeList');
        }
        else{
            $(this).prev('.lp_countries_lin').addClass('selectedBeforeList');
        }
        
    });


    // Countries where

    var countryTranslationsLu = {
        "United Kingdom": "in the United Kingdom",
        "Belgium": "in Belgium",
        "Germany": "in Germany",
        "Netherlands": "in the Netherlands",
        "Poland": "in Poland",
        "Austria": "in Austria",
        "France": "in France",
        "Lithuania": "in Lithuania",
        "Luxembourg": "in Luxembourg"
    };

    
    var countryTranslationsDe = {
        "United Kingdom": "im Vereinigten Königreich",
        "Belgium": "in Belgien",
        "Germany": "in Deutschland",
        "Netherlands": "in den Niederlanden",
        "Poland": "in Polen",
        "Austria": "in Österreich",
        "France": "in Frankreich",
        "Lithuania": "in Litauen",
        "Luxembourg": "in Luxemburg"
    };
    
    var countryTranslationsLt = {
        "United Kingdom": "Jungtinėje Karalystėje",
        "Belgium": "Belgijoje",
        "Germany": "Vokietijoje",
        "Netherlands": "Nyderlanduose",
        "Poland": "Lenkijoje",
        "Austria": "Austrijoje",
        "France": "Prancūzijoje",
        "Lithuania": "Lietuvoje",
        "Luxembourg": "Liuksemburge"
    };
    
    var countryTranslationsFr = {
        "United Kingdom": "au Royaume-Uni",
        "Belgium": "en Belgique",
        "Germany": "en Allemagne",
        "Netherlands": "aux Pays-Bas",
        "Poland": "en Pologne",
        "Austria": "en Autriche",
        "France": "en France",
        "Lithuania": "en Lituanie",
        "Luxembourg": "au Luxembourg"
    };
    
    var countryTranslationsBe = {
        "United Kingdom": "in het Verenigd Koninkrijk",
        "Belgium": "in België",
        "Germany": "in Duitsland",
        "Netherlands": "in Nederland",
        "Poland": "in Polen",
        "Austria": "in Oostenrijk",
        "France": "in Frankrijk",
        "Lithuania": "in Litouwen",
        "Luxembourg": "in Luxemburg"
    };
    
    var countryTranslationsNl = {
        "United Kingdom": "in het Verenigd Koninkrijk",
        "Belgium": "in België",
        "Germany": "in Duitsland",
        "Netherlands": "in Nederland",
        "Poland": "in Polen",
        "Austria": "in Oostenrijk",
        "France": "in Frankrijk",
        "Lithuania": "in Litouwen",
        "Luxembourg": "in Luxemburg"
    };
    
    var countryTranslationsUk = {
        "United Kingdom": "in the United Kingdom",
        "Belgium": "in Belgium",
        "Germany": "in Germany",
        "Netherlands": "in the Netherlands",
        "Poland": "in Poland",
        "Austria": "in Austria",
        "France": "in France",
        "Lithuania": "in Lithuania",
        "Luxembourg": "in Luxembourg"
    };

    var countryTranslationsPl = {
        "United Kingdom": "w Wielkiej Brytanii",
        "Belgium": "w Belgii",
        "Germany": "w Niemczech",
        "Netherlands": "w Holandii",
        "Poland": "w Polsce",
        "Austria": "w Austrii",
        "France": "we Francji",
        "Lithuania": "na Litwie",
        "Luxembourg": "w Luksemburgu"
    };
    


    // Countries who?

    var countryTranMainLu = {
        "United Kingdom": "United Kingdom",
        "Belgium": "Belgium",
        "Germany": "Germany",
        "Netherlands": "Netherlands",
        "Poland": "Poland",
        "Austria": "Austria",
        "France": "France",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg"
    };

    
    var countryTranMainDe = {
        "United Kingdom": "Vereinigtes Königreich",
        "Belgium": "Belgien",
        "Germany": "Deutschland",
        "Netherlands": "Niederlande",
        "Poland": "Polen",
        "Austria": "Österreich",
        "France": "Frankreich",
        "Lithuania": "Litauen",
        "Luxembourg": "Luxemburg"
    };
    
    var countryTranMainLt = {
        "United Kingdom": "Jungtinė Karalystė",
        "Belgium": "Belgija",
        "Germany": "Vokietija",
        "Netherlands": "Nyderlandai",
        "Poland": "Lenkija",
        "Austria": "Austrija",
        "France": "Prancūzija",
        "Lithuania": "Lietuva",
        "Luxembourg": "Liuksemburgas"
    };
    
    var countryTranMainFr = {
        "United Kingdom": "Royaume-Uni",
        "Belgium": "Belgique",
        "Germany": "Allemagne",
        "Netherlands": "Pays-Bas",
        "Poland": "Pologne",
        "Austria": "Autriche",
        "France": "France",
        "Lithuania": "Lituanie",
        "Luxembourg": "Luxembourg"
    };
    
    var countryTranMainBe = {
        "United Kingdom": "Verenigd Koninkrijk",
        "Belgium": "België",
        "Germany": "Duitsland",
        "Netherlands": "Nederland",
        "Poland": "Polen",
        "Austria": "Oostenrijk",
        "France": "Frankrijk",
        "Lithuania": "Litouwen",
        "Luxembourg": "Luxemburg"
    };
    
    var countryTranMainNl = {
        "United Kingdom": "Verenigd Koninkrijk",
        "Belgium": "België",
        "Germany": "Duitsland",
        "Netherlands": "Nederland",
        "Poland": "Polen",
        "Austria": "Oostenrijk",
        "France": "Frankrijk",
        "Lithuania": "Litouwen",
        "Luxembourg": "Luxemburg"
    };
    
    var countryTranMainUk = {
        "United Kingdom": "United Kingdom",
        "Belgium": "Belgium",
        "Germany": "Germany",
        "Netherlands": "Netherlands",
        "Poland": "Poland",
        "Austria": "Austria",
        "France": "France",
        "Lithuania": "Lithuania",
        "Luxembourg": "Luxembourg"
    };
    
    var countryTranMainPl = {
        "United Kingdom": "Wielka Brytania",
        "Belgium": "Belgia",
        "Germany": "Niemcy",
        "Netherlands": "Holandia",
        "Poland": "Polska",
        "Austria": "Austria",
        "France": "Francja",
        "Lithuania": "Litwa",
        "Luxembourg": "Luksemburg"
    };
    
    
});